var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59136 0.807088C7.8321 0.619846 8.1692 0.619846 8.40994 0.807088L14.4099 5.47375C14.5723 5.60006 14.6673 5.79426 14.6673 5.99999V13.3333C14.6673 13.8638 14.4566 14.3725 14.0815 14.7475C13.7065 15.1226 13.1978 15.3333 12.6673 15.3333H3.33398C2.80355 15.3333 2.29484 15.1226 1.91977 14.7475C1.5447 14.3725 1.33398 13.8638 1.33398 13.3333V5.99999C1.33398 5.79426 1.42897 5.60006 1.59136 5.47375L7.59136 0.807088ZM2.66732 6.32605V13.3333C2.66732 13.5101 2.73756 13.6797 2.86258 13.8047C2.9876 13.9298 3.15717 14 3.33398 14H12.6673C12.8441 14 13.0137 13.9298 13.1387 13.8047C13.2637 13.6797 13.334 13.5101 13.334 13.3333V6.32605L8.00065 2.1779L2.66732 6.32605Z",
    fill: "#313237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33398 8.00001C5.33398 7.63182 5.63246 7.33334 6.00065 7.33334H10.0007C10.3688 7.33334 10.6673 7.63182 10.6673 8.00001V14.6667C10.6673 15.0349 10.3688 15.3333 10.0007 15.3333C9.63246 15.3333 9.33398 15.0349 9.33398 14.6667V8.66668H6.66732V14.6667C6.66732 15.0349 6.36884 15.3333 6.00065 15.3333C5.63246 15.3333 5.33398 15.0349 5.33398 14.6667V8.00001Z",
    fill: "#313237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.cc8b8b662fc4912ff704f1e0512be4eb.svg";
export { ForwardRef as ReactComponent };